<template>
  <div>
    <v-dialog
      v-model="dialog"
      fullscreen
      persistent
      no-click-animation
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <BarTitleDialog
          :title="title"
          @close="close"
        />
        <v-card-actions>
          <v-row class="">
            <v-col>
              <v-btn
                v-if="editedItem.id"
                x-large
                style="background:#d3d3d3"
                @click="showDialogResendVoucher()"
              >
                <v-icon>{{ icons.mdiEmailSyncOutline }}</v-icon> Reenviar Voucher
              </v-btn>
              <v-btn
                v-if="editedItem.id"
                class="ml-4"
                x-large
                style="background:#d3d3d3"
                @click="showDialogResendWhatsVoucher()"
              >
                <v-icon>{{ icons.mdiWhatsapp }}</v-icon> Reenviar Voucher
              </v-btn>
              <v-btn
                v-if="editedItem.status == 'canceled'"
                class="ml-4"
                x-large
                style="background:#d3d3d3"
                @click="reOpenButton()"
              >
                <v-icon>{{ icons.mdiRestore }}</v-icon> Reativar Reserva
              </v-btn>
            </v-col>
            <v-col class="text-right">
              <v-btn
                color="blue darken-1"
                x-large
                class="mr-2"
                text
                @click="close"
              >
                Fechar
              </v-btn>
              <v-btn
                :loading="loading"
                x-large
                color="primary"
                @click="save"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
        <v-divider></v-divider>
        <v-card-text>
          <v-container>
            <v-row no-gutters>
              <v-col cols="3">
                <SelectCategoryRoom
                  v-model="editedItem.room_category_id"
                  :errors="errors.room_category_id"
                  class="mr-4"
                  @change="getVerifyRoom(); applyRatePlanValue()"
                />
              </v-col>
              <v-col
                offset="4"
                cols="3"
              >
                <v-switch
                  v-model="editedItem.with_iss"
                  true-value="yes"
                  false-value="not"
                  label="Com ISS"
                  @change="calcAccommodationValue"
                ></v-switch>
              </v-col>
              <v-col cols="2">
                <vuetify-money
                  v-model="editedItem.accommodation_value"
                  label="Valor da Hospedagem"
                  disabled
                  outlined
                ></vuetify-money>
              </v-col>
            </v-row>
            <v-row>
            </v-row>
            <v-row
              no-gutters
              class=""
            >
              <v-col cols="">
                <v-switch
                  v-model="editedItem.tariff_manual"
                  true-value="yes"
                  false-value="not"
                  label="Tarifa Manual"
                  @change="onTariffManualChange"
                ></v-switch>
              </v-col>

              <v-col
                v-if="editedItem.tariff_manual == 'not'"
                cols="3"
              >
                <v-autocomplete
                  v-model="selectedRatePlanId"
                  :items="ratePlans"
                  item-value="id"
                  item-text="description"
                  label="Tarifário"
                  outlined
                  hide-details
                  clearable
                  class="mr-2"
                  @change="applyRatePlanValue()"
                />
              </v-col>
              <v-col
                v-if="editedItem.tariff_manual == 'not' && !selectedRatePlanId"
                cols="3"
              >
                <SelectTariff
                  v-model="editedItem.tariff_id"
                  :errors="errors.tariff_id"
                  class="mr-4"
                  @change="errors.tariff_id = null"
                  @object="setTariffObject"
                />
              </v-col>

              <v-col
                v-if="editedItem.tariff_manual == 'yes'"
                cols="3"
              >
                <vuetify-money
                  v-model="tariff_manual_value"
                  :error-messages="errors.tariff_manual_value"
                  outlined
                  label="Tarifa"
                  hint="Aceita R$ 0,00 para cortesia"
                  persistent-hint
                  class="mr-4"
                />
              </v-col>

              <v-col cols="">
                <input-date
                  v-model="editedItem.check_in"
                  :errors="errors.check_in"
                  :label="'Check-in'"
                  :dense="false"
                  @change="createTarif()"
                ></input-date>
              </v-col>

              <v-col cols="">
                <input-date
                  v-model="editedItem.check_out"
                  :errors="errors.check_out"
                  :dense="false"
                  :label="'Check-out'"
                  :css="'ml-4'"
                  @change="createTarif()"
                ></input-date>
              </v-col>

              <v-col>
                <v-btn
                  color="primary"
                  class="ml-4"
                  @click="showDialogTariffExtraordinary"
                >
                  <v-icon>{{ icons.mdiPencilOutline }}</v-icon>tarifas
                </v-btn>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="10">
                <!-- <SelectChipMutipleRoom  v-model="editedItem.room"/> -->
                <v-select
                  v-model="editedItem.room"
                  chips
                  multiple
                  outlined
                  return-object
                  :loading="loadingSelectRoom"
                  :disabled="loadingSelectRoom"
                  label="Quartos"
                  :items="rooms"
                  item-text="description"
                  item-value="id"
                  @change="onRoomChange"
                ></v-select>
              </v-col>
              <v-col>
                <vuetify-money
                  v-model="editedItem.qtd_room"
                  :disabled="ablQtdRoom"
                  outlined
                  type="number"
                  label="Qtd. Quartos"
                  :options="{ locale: 'pt-BR', length: 3, precision: 0 }"
                  class="ml-4"
                  :error-messages="errors.qtd_room"
                  @input="errors.qtd_room = null"
                />
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" md="4">
                <AutocompleteSearchCompany
                  v-model="company"
                  :errors="errors.company_id"
                  @change="changeCompany"
                />
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="requester"
                  class="ml-4"
                  outlined
                  label="Solicitante"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="3">
                <v-text-field
                  v-model="editedItem.origin"
                  class="ml-4"
                  outlined
                  label="Canal de Solicitação"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="2">
                <vuetify-money
                  v-model="editedItem.children_count"
                  outlined
                  type="number"
                  label="Qtd. Crianças"
                  :options="{ locale: 'pt-BR', length: 3, precision: 0 }"
                  class="ml-4"
                />
              </v-col>
            </v-row>

            <v-row
              v-if="canShowCorporateBilling"
              no-gutters
              class="mt-3 mb-4"
            >
              <v-col cols="12">
                <v-card outlined>
                  <v-card-text class="pb-5">
                    <v-row
                      no-gutters
                      align="center"
                    >
                      <v-col
                        cols="12"
                        md="6"
                        class="mb-1 mb-md-0"
                      >
                        <div class="subtitle-2 font-weight-bold">
                          Faturamento corporativo
                        </div>
                        <div class="caption">
                          Disponível apenas para empresas com faturamento liberado.
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        class="text-md-right"
                      >
                        <v-switch
                          v-model="editedItem.billing_checkout_enabled"
                          :disabled="!companyAllowsBilling"
                          label="Cobrar na conta da empresa (faturado)"
                          class="mt-0 pt-0"
                        />
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="!companyAllowsBilling"
                      no-gutters
                      class="mt-1"
                    >
                      <v-col
                        cols="12"
                        class="caption error--text"
                      >
                        Esta empresa não possui faturamento corporativo liberado.
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="editedItem.billing_checkout_enabled"
                      no-gutters
                      class="mt-2"
                    >
                      <v-col
                        cols="12"
                        md="6"
                        class="pr-md-2"
                      >
                        <v-select
                          v-model="editedItem.billing_checkout_scope"
                          :items="billingScopes"
                          item-text="text"
                          item-value="value"
                          label="O que será faturado?"
                          outlined
                          :disabled="!editedItem.billing_checkout_enabled"
                          :error-messages="errors.billing_checkout_scope"
                          @change="errors.billing_checkout_scope = null"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        md="6"
                        class="pl-md-2 d-flex align-center"
                      >
                        <div class="caption mt-1 mt-md-0">
                          <span v-if="loadingCompanyCredit">Consultando crédito disponível...</span>
                          <template v-else-if="editedItem.id && originalCreditLock > 0">
                            <div>Crédito disponível: {{ formatMoneyBR(companyCredit.available) }}</div>
                            <div class="font-weight-medium">
                              Crédito efetivo para esta reserva: {{ formatMoneyBR(companyCredit.available + originalCreditLock) }}
                            </div>
                          </template>
                          <span v-else>Crédito disponível: {{ formatMoneyBR(companyCredit.available) }}</span>
                        </div>
                      </v-col>
                    </v-row>

                    <v-row
                      v-if="editedItem.billing_checkout_enabled && !loadingCompanyCredit && companyCredit.billing_blocked"
                      no-gutters
                      class="mt-2"
                    >
                      <v-col cols="12">
                        <v-alert
                          type="error"
                          dense
                          class="mb-0"
                        >
                          <strong>Faturamento bloqueado:</strong>
                          faturas vencidas há <strong>{{ companyCredit.overdue_days }} dias</strong>
                          <span v-if="companyCredit.billing_overdue_tolerance != null">(tolerância: {{ companyCredit.billing_overdue_tolerance }} dias)</span>.
                        </v-alert>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12">
                <TableGuest
                  :errors="errors.guest"
                  @change="errors.guest = null; errors.company_id = null"
                />
              </v-col>
            </v-row>

            <v-row class="mt-2">
              <v-col>
                <v-textarea
                  v-model="editedItem.external_tracker"
                  rows="1"
                  outlined
                  label="Localizador Externo"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="editedItem.obs"
                  rows="6"
                  outlined
                  label="Observação"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <v-textarea
                  v-model="editedItem.internal_note"
                  rows="3"
                  outlined
                  label="Notas Internas"
                >
                </v-textarea>
              </v-col>
            </v-row>
            <v-row
              class=""
              no-gutters
            >
              <v-col>
                <v-textarea
                  v-model="editedItem.justify_cancel"
                  rows="2"
                  outlined
                  label="Justificativa de Cancelamento"
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- DIALOG TARIFAS EXTRAORDINARIAS -->
    <v-dialog
      v-model="dialogTariffExtraordinary"
      persistent
      width="600"
    >
      <v-card>
        <BarTitleDialog
          title="Tarifas"
          @close="dialogTariffExtraordinary = false"
        />
        <v-card-text>
          <!-- v-for=" tariff in editedItem.extraordinary_tariff   " -->
          <v-row
            v-for="(tariff, index) in extraordinary_tariff"
            :key="index"
            no-gutters
            class="mb-2"
          >
            <v-col>
              <vuetify-money
                v-model="tariff.value"
                :option="{ prefix: 'R$' }"
                dense
                outlined
                hide-details
              ></vuetify-money>
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                readonly
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_start)"
                label="Data Inicio"
              ></v-text-field>
              <!-- <input-date css="ml-2"  v-model="tariff.date_start" :label="'Data Inicial'" :dense="true"></input-date> -->
            </v-col>
            <v-col>
              <v-text-field
                hide-details=""
                readonly
                class="ml-2"
                outlined
                dense
                :value="formatDate(tariff.date_end)"
                label="Data Fim"
              ></v-text-field>
              <!-- <input-date css="ml-2"  v-model="tariff.date_end" :label="'Data Final'" :dense="true"></input-date> -->
            </v-col>
            <!-- <v-col cols="1">
                        <v-btn icon color="error" class="ml-2" @click="removeTariffExtraordinary(tariff)" >
                            <v-icon>{{ icons.mdiDeleteOutline }}</v-icon>
                        </v-btn>
                    </v-col> -->
          </v-row>
          <!-- <v-row>
                    <v-col class="text-center">
                        <v-btn rounded  color="secondary" @click="addTariffExtraordinary()" >
                            <v-icon>{{ icons.mdiPlus }}</v-icon>
                            Adicionar Tarifa
                        </v-btn>
                    </v-col>
                </v-row> -->
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                x-large
                color="secondary"
                text
                class="mr-4"
                @click="dialogTariffExtraordinary = false"
              >
                fechar
              </v-btn>
              <v-btn
                x-large
                color="primary"
                @click="confirmExtraordinaryTariff()"
              >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG DESJA ENVIAR EMAIL -->
    <v-dialog
      v-model="dialogSave"
      max-width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="enviar Voucher"
          @close="dialogSave = false"
        ></BarTitleDialog>
        <v-card-title class="text-h5 text-center">
          <v-row no-gutters>
            <v-col>Deseja enviar voucher?</v-col>
          </v-row>
          <v-expand-transition>
            <v-row
              v-if="activeEmailVoucher"
              no-gutters
              class="mt-4"
            >
              <v-col class="col-2">
                <img
                  class="svg-icon"
                  src="@/assets/images/svg/email.svg"
                  alt="Ícone de E-mail"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="emailVoucher"
                  outlined
                  label="email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expand-transition>
          <v-expand-transition>
            <v-row
              v-if="activeWhatsVoucher"
              no-gutters
            >
              <v-col class="col-2">
                <img
                  class="svg-icon"
                  src="@/assets/images/svg/whats.svg"
                  alt="Ícone de E-mail"
                />
              </v-col>
              <v-col>
                <v-text-field
                  v-model="editedItem.whats_voucher"
                  v-mask="whatsVoucherMask"
                  outlined
                  label="Número Whatsapp"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-expand-transition>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                :loading="loading_not"
                class="mr-4"
                x-large
                color="secondary"
                @click="loading_not = true; confirmSave()"
              >
                Não
              </v-btn>

              <v-btn
                v-if="activeEmailVoucher == false"
                x-large
                color="primary"
                :loading="loading"
                @click="activeEmailVoucher = true; activeWhatsVoucher = true"
              >
                Sim
              </v-btn>
              <v-btn
                v-if="activeEmailVoucher == true"
                x-large
                color="primary"
                :loading="loading"
                @click="loading = true; confirmSave()"
              >
                ENVIAR
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG REEENVIAR VOUCHER  -->
    <v-dialog
      v-model="dialogResendVoucher"
      max-width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="enviar Voucher"
          @close="dialogResendVoucher = false"
        ></BarTitleDialog>
        <v-card-text>
          <v-row no-gutters>
            <v-col>
              <v-text-field
                v-model="emailResendVoucherComp"
                outlined
                label="email"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                class="mr-4"
                x-large
                color="secondary"
                @click="dialogResendVoucher = false"
              >
                Não
              </v-btn>

              <v-btn
                x-large
                color="primary"
                :loading="loadingResendVoucher"
                :disabled="loadingResendVoucher"
                @click="sendVoucher()"
              >
                enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG REEENVIAR Whats VOUCHER  -->
    <v-dialog
      v-model="dialogResendVoucherWhats"
      max-width="500px"
    >
      <v-card>
        <BarTitleDialog
          title="enviar Voucher"
          @close="dialogResendVoucherWhats = false"
        ></BarTitleDialog>
        <v-card-text>
          <v-row no-gutters>
            <v-col class="col-2">
              <img
                class="svg-icon"
                src="@/assets/images/svg/whats.svg"
                alt="Ícone de E-mail"
              />
            </v-col>
            <v-col>
              <v-text-field
                v-model="whatsResendVoucherComp"
                v-mask="whatsResendCompMask"
                outlined
                label="Número Whatsapp"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-row>
            <v-col class="text-right">
              <v-btn
                class="mr-4"
                x-large
                color="secondary"
                @click="dialogResendVoucherWhats = false"
              >
                Não
              </v-btn>
              <v-btn
                x-large
                color="primary"
                :loading="loadingResendVoucher"
                :disabled="loadingResendVoucher"
                @click="sendVoucherWhats()"
              >
                enviar
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  mdiClose,
  mdiDeleteOutline,
  mdiPencilOutline,
  mdiPlus,
  mdiFileExportOutline,
  mdiEmailSyncOutline,
  mdiWhatsapp,
  mdiRestore,
} from '@mdi/js'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import BarTitleDialog from '@/components/BarTitleDialog.vue'
import SelectCategoryRoom from '@/components/SelectCategoryRoom.vue'
import SelectChipMutipleRoom from '@/components/SelectChipMutipleRoom.vue'
import SelectTariff from '@/components/SelectTariff.vue'
import InputDate from '@/components/InputDate.vue'
import TableGuest from './TableGuest.vue'

import AutocompleteSearchCompany from '@/components/AutocompleteSearchCompany.vue'

export default {
  components: {
    BarTitleDialog,
    InputDate,
    TableGuest,
    AutocompleteSearchCompany,
    SelectCategoryRoom,
    SelectChipMutipleRoom,
    SelectTariff,
  },

  props: {
    value: {
      type: Boolean,
    },
    in_data: {
      type: Object,
    }, // recebe os dados do hospede
    title: {
      type: String,
    },
  },
  data: () => ({
    // RESEND VOUCHER
    dialogResendVoucher: false,
    dialogResendVoucherWhats: false,
    emailResendVoucher: null,
    whatsResendVoucher: null,
    loadingResendVoucher: false,

    // END RESEND VOUCHER
    loading_not: false,
    loadingSelectRoom: false,
    activeEmailVoucher: false,
    activeWhatsVoucher: false,
    dialogSave: false,
    extraordinary_tariff: [],
    tariff: {},
    dialogTariffExtraordinary: false,
    dialogDelete: false,
    loadingRooms: false,
    dialog: false,
    loading: false,
    rooms: [],
    guests: [],
    guest: {},
    ratePlans: [],
    selectedRatePlanId: null,
    ratePlanItem: null,
    tariffObject: {},
    autoTariffEnabled: true,
    whatsResendVoucherComp: '',
    tariff_manual_value: '',
    loadingCompanyCredit: false,
    companyCredit: {
      available: 0,
      billing_limit: 0,
      consumed: 0,
      billing_blocked: false,
      overdue_days: 0,
      billing_overdue_tolerance: null,
    },
    originalCreditLock: 0,
    lastNoCreditWarningCompanyId: null,
    billingScopes: [
      { text: 'Total da conta', value: 'total' },
      { text: 'Somente hospedagem', value: 'accommodation' },
      { text: 'Somente consumo', value: 'consumption' },
    ],
    company: '',
    editedItem: {
      check_in: '',
      check_out: '',
      company_id: '',
      billing_checkout_enabled: false,
      billing_checkout_scope: null,
      origin: null,
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    defaultItem: {
      check_in: '',
      check_out: '',
      company_id: '',
      billing_checkout_enabled: false,
      billing_checkout_scope: null,
      origin: null,
      room: [],
      tariff_manual: 'not',
      with_iss: 'not',
    },
    errors: {
      room_category_id: null,
      tariff_id: null,
      tariff_manual_value: null,
      check_in: null,
      check_out: null,
      company_id: null,
      billing_checkout_scope: null,
      guest: null,
      qtd_room: null,
      room: [],
    },
    options: {},
    tab: null,
    icons: {
      mdiPencilOutline,
      mdiDeleteOutline,
      mdiPlus,
      mdiClose,
      mdiFileExportOutline,
      mdiEmailSyncOutline,
      mdiWhatsapp,
      mdiRestore,
    },
  }),

  watch: {
    value(val) {
      this.dialog = val
      if (val) {
        const isEditing = Boolean(this.in_data && this.in_data.id)
        this.autoTariffEnabled = !isEditing

        // Faz uma cópia profunda do in_data para evitar mutação do objeto original
        this.editedItem = {
          ...this.defaultItem,
          ...JSON.parse(JSON.stringify(this.in_data)),
        }
        this.company = this.in_data.company // company mantém referência para funcionar corretamente
        this.editedItem.billing_checkout_enabled = Boolean(this.editedItem.billing_checkout_enabled)
        this.editedItem.billing_checkout_scope = this.editedItem.billing_checkout_scope || null

        // Faz uma cópia profunda das tarifas para evitar mutação do objeto original
        this.extraordinary_tariff = this.editedItem.extraordinary_tariff
          ? JSON.parse(JSON.stringify(this.editedItem.extraordinary_tariff))
          : []
        this.tariff_manual_value = this.editedItem.tariff_manual_value
        this.tariffObject = this.in_data.tariff ? { ...this.in_data.tariff } : {}

        if (isEditing && this.in_data.billing_checkout_enabled) {
          const scope = this.in_data.billing_checkout_scope
          const validScope = ['total', 'accommodation', null].includes(scope)
          if (validScope) {
            const rate = parseFloat(this.in_data.accommodation_value || 0)
            const qty = Math.max(1, parseInt(this.in_data.qtd_room || 1))
            this.originalCreditLock = rate * qty
          } else {
            this.originalCreditLock = 0
          }
        } else {
          this.originalCreditLock = 0
        }

        if (this.company) {
          this.syncBillingByCompany(this.company)
        } else {
          this.resetBillingSettings()
        }

        if (isEditing) {
          this.$nextTick(() => {
            this.autoTariffEnabled = true
          })
        }
      }
    },
    dialog(val) {
      this.$emit('input', val)
      if (!val) {
        this.close()
      }
    },
    tariff_manual_value(val) {
      this.errors.tariff_manual_value = null // limpa message de error
      this.editedItem.tariff_manual_value = val

      // Recria tarifas diárias se já existirem datas
      if (this.editedItem.check_in && this.editedItem.check_out) {
        this.createTarif()
      }
    },
    'editedItem.tariff_manual': function (val) {
      // Quando ativar tarifa manual, inicializa com 0 se estiver vazio
      if (val === 'yes' && (this.tariff_manual_value === null || this.tariff_manual_value === undefined || this.tariff_manual_value === '')) {
        this.tariff_manual_value = 0
      }

      // Recria tarifas quando alterna entre manual e padrão
      if (this.editedItem.check_in && this.editedItem.check_out) {
        this.createTarif()
      }
    },
    'editedItem.billing_checkout_enabled': function (val) {
      if (!val) {
        this.editedItem.billing_checkout_scope = null
        this.errors.billing_checkout_scope = null
      }
    },
  },

  created() {
    this.loadRatePlans().then(res => { this.ratePlans = res.data })
  },

  computed: {
    ...mapGetters('reserve', ['getGuests']),
    ...mapGetters('config', {
      issRate: 'getIssRate',
    }),
    canShowCorporateBilling() {
      return Boolean(this.company)
    },
    companyAllowsBilling() {
      if (!this.company) {
        return false
      }

      return this.normalizeBoolean(this.company.allow_billing)
    },
    cell_phone() {
      if (this.editedItem.guest) {
        return this.editedItem.guest.cell_phone
      }
    },
    email() {
      if (this.editedItem.guest) {
        return this.editedItem.guest.email
      }
    },
    ablQtdRoom() {
      if (this.editedItem.room.length > 0) {
        return true
      }

      return false
    },
    requester: {
      get() {
        return this.editedItem.requester
      },
      set(val) {
        this.editedItem.requester = val[0].toUpperCase() + val.substring(1)
      },
    },
    emailVoucher: {
      get() {
        return this.editedItem.email_voucher
      },
      set(val) {
        this.editedItem.email_voucher = val.toLowerCase()
      },
    },
    whatsVoucherMask: {
      get() {
        const val = this.editedItem.whats_voucher || ''
        if (val.startsWith('+')) return '+###############' // internacional

        return '(##)#####-####'
      },

    },
    whatsResendCompMask: {
      get() {
        const val = this.whatsResendVoucherComp || ''
        if (val.startsWith('+')) return '+###############' // internacional

        return '(##)#####-####'
      },

    },

    emailResendVoucherComp: {
      get() {
        return this.emailResendVoucher
      },
      set(val) {
        this.emailResendVoucher = val.toLowerCase()
      },
    },
  },

  methods: {
    ...mapActions('reserve', ['store', 'update', 'getRooms', 'exportPdf', 'setGuests', 'verifyRoom', 'resendVoucher', 'resendWhatsVoucher', 'reOpen', 'findReserve']),
    ...mapActions('company', ['getCompanyCredit']),
    ...mapActions('rate_plan', { loadRatePlans: 'getForSelect' }),
    ...mapMutations('reserve', ['setGuests']),

    normalizeBoolean(value) {
      return value === true || value === 1 || value === '1' || value === 'yes' || value === 'true' || value === 'sim'
    },
    formatMoneyBR(value) {
      const amount = Number(value || 0)

      return amount.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      })
    },
    resetBillingSettings() {
      this.editedItem.billing_checkout_enabled = false
      this.editedItem.billing_checkout_scope = null
      this.errors.billing_checkout_scope = null
      this.lastNoCreditWarningCompanyId = null
      this.companyCredit = {
        available: 0,
        billing_limit: 0,
        consumed: 0,
      }
      this.loadingCompanyCredit = false
    },
    syncBillingByCompany(company) {
      if (!company) {
        this.resetBillingSettings()

        return
      }

      if (!this.normalizeBoolean(company.allow_billing)) {
        this.resetBillingSettings()

        return
      }

      this.fetchCompanyCredit(company)
    },
    fetchCompanyCredit(company) {
      if (!company || !company.id) {
        this.resetBillingSettings()

        return
      }

      this.loadingCompanyCredit = true
      this.getCompanyCredit(company.id)
        .then(response => {
          const creditData = (response.data && response.data.data) ? response.data.data : {}
          this.companyCredit = {
            available: Number(creditData.available || 0),
            billing_limit: Number(creditData.billing_limit || 0),
            consumed: Number(creditData.consumed || 0),
            billing_blocked: Boolean(creditData.billing_blocked),
            overdue_days: Number(creditData.overdue_days || 0),
            billing_overdue_tolerance: creditData.billing_overdue_tolerance ?? null,
          }

          if (this.companyCredit.available <= 0) {
            if (this.lastNoCreditWarningCompanyId !== company.id) {
              this.lastNoCreditWarningCompanyId = company.id
              this.$swal({
                confirmButtonColor: '#16b1ff',
                position: 'center',
                html: '<p>Esta empresa está sem saldo disponível para faturamento corporativo. Você pode escolher o escopo, mas a reserva não será salva com faturamento ativo sem saldo.</p>',
                icon: 'warning',
                title: 'Atenção',
              })
            }
          }
        })
        .catch(() => {
          this.companyCredit = {
            available: 0,
            billing_limit: 0,
            consumed: 0,
            billing_blocked: false,
            overdue_days: 0,
            billing_overdue_tolerance: null,
          }
          this.$toast.error('Não foi possível validar o crédito da empresa agora. Tente novamente.')
        })
        .finally(() => {
          this.loadingCompanyCredit = false
        })
    },

    inicialize() { },
    getVerifyRoom() {
      this.errors.room_category_id = null // apaga a menssagem de erro

      // se checki nao tem data não fa requisicao
      if (this.editedItem.check_in == null || this.editedItem.check_in == undefined || this.editedItem.check_in == '') {
        return false
      }

      // se checkout nao tem data não fa requisicao
      if (
        this.editedItem.check_out == null
        || this.editedItem.check_out == undefined
        || this.editedItem.check_out == ''
      ) {
        return false
      }

      if (this.editedItem.room_category_id == null || this.editedItem.room_category_id == undefined) {
        return false
      }

      const params = {
        room_category_id: this.editedItem.room_category_id,
        check_in: this.editedItem.check_in,
        check_out: this.editedItem.check_out,
      }
      this.rooms = this.in_data.room

      this.verifyRoom(params).then(response => {
        this.rooms = [...this.rooms, ...response.data]
      })
    },

    showDialogTariffExtraordinary() {
      this.dialogTariffExtraordinary = true
    },

    // addTariffExtraordinary(){
    //    this.extraordinary_tariff.push({ value:0, date_start:'', date_end:''})

    // },
    // removeTariffExtraordinary(tariff){
    //    const index = this.extraordinary_tariff.indexOf(tariff);
    //    this.extraordinary_tariff.splice(index ,1)

    // },
    onTariffManualChange(val) {
      if (val === 'yes') {
        this.selectedRatePlanId = null
        this.ratePlanItem = null
      }
    },

    setTariffObject(object) {
      this.tariffObject = object
      this.createTarif() // Recria tarifas diárias com novo valor
    },

    applyRatePlanValue() {
      const categoryId = this.editedItem.room_category_id
      if (!this.selectedRatePlanId || !categoryId) return
      const plan = this.ratePlans.find(rp => rp.id === this.selectedRatePlanId)
      if (!plan) return
      const item = (plan.items || []).find(i => i.room_category_id === categoryId)
      if (!item) return
      this.ratePlanItem = item
      this.tariffObject = { value: parseFloat(item.value) }
      this.createTarif()
    },

    resolveDayValue(date, baseValue) {
      if (this.ratePlanItem) {
        const dateStr = date.toISOString().split('T')[0]
        const specialRates = this.ratePlanItem.special_rates || []
        const special = specialRates.find(sr => sr.date === dateStr)
        if (special !== undefined) return parseFloat(special.value)
        const dow = date.getDay()
        const isWeekend = dow === 5 || dow === 6
        const wv = this.ratePlanItem.weekend_value
        if (isWeekend && wv !== null && wv !== undefined && wv !== '') {
          return parseFloat(wv)
        }
      }

      return baseValue
    },

    createTarif(force = false) {
      if (!force && !this.autoTariffEnabled) {
        return
      }

      if (!this.editedItem.check_in || !this.editedItem.check_out) {
        return
      }

      this.errors.check_out = null
      this.errors.check_in = null

      this.getVerifyRoom()

      const checkIn = new Date(this.editedItem.check_in)
      const diffInMs = new Date(this.editedItem.check_out) - new Date(this.editedItem.check_in)
      const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

      let baseValue = 0

      if (this.editedItem.tariff_manual === 'yes') {
        baseValue = this.editedItem.tariff_manual_value
      } else {
        if (!this.tariffObject || this.tariffObject.value === undefined) {
          return
        }
        baseValue = this.tariffObject.value
      }

      const tariffs = []

      if (diffInDays === 0) {
        const dateStr = checkIn.toISOString().split('T')[0]
        tariffs.push({ value: this.resolveDayValue(checkIn, baseValue), date_start: dateStr, date_end: dateStr })
      } else {
        for (let i = 0; i < diffInDays; i += 1) {
          const dateStart = checkIn.toISOString().split('T')[0]
          const dayValue = this.resolveDayValue(checkIn, baseValue)
          checkIn.setDate(checkIn.getDate() + 1)
          const dateEnd = checkIn.toISOString().split('T')[0]
          tariffs.push({ value: dayValue, date_start: dateStart, date_end: dateEnd })
        }
      }

      this.extraordinary_tariff = tariffs
      this.calcAccommodationValue()
    },

    calcAccommodationValue() {
      if (this.extraordinary_tariff != undefined || this.extraordinary_tariff > 0) {
        let result = this.extraordinary_tariff.reduce((acc, tariff) => acc + parseFloat(tariff.value), 0)

        // calc de iss
        if (this.editedItem.with_iss == 'yes') {
          if (result > 0) {
            const iss = result * this.issRate
            result += iss
          }
        }

        this.editedItem.accommodation_value = result
      }
    },

    // calcExtraordinayTariff(){

    //     const value = this.extraordinary_tariff.reduce((acc,tariff) => {
    //       const diffInMs = new Date(tariff.date_end) - new Date(tariff.date_start)
    //       const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

    //       return acc + (diffInDays * tariff.value)
    //     },0);

    //     const days = this.extraordinary_tariff.reduce((acc,tariff) => {
    //       const diffInMs = new Date(tariff.date_end) - new Date(tariff.date_start)
    //       const diffInDays = diffInMs / (1000 * 60 * 60 * 24)

    //       return acc + diffInDays
    //     },0);

    //     // console.log({value,days})
    //     return {value,days}

    // },
    confirmExtraordinaryTariff() {
      // Garante que todos os valores sejam números
      this.extraordinary_tariff = this.extraordinary_tariff.map(tariff => ({
        ...tariff,
        value: parseFloat(tariff.value) || 0,
      }))
      this.calcAccommodationValue()
      this.dialogTariffExtraordinary = false
    },
    changeCompany(company) {
      this.errors.company_id = null // retirar o error
      this.errors.guest = null // retirar o error
      if (company) {
        if (company.situation == '2') {
          this.$swal({
            confirmButtonColor: '#16b1ff',
            position: 'center',
            html: '<p>' + 'Esta empresa está com o faturamento bloqueado' + '</p>',
            icon: 'warning',
            title: 'Atenção',
          })
        }
        if (company.rate_plan_id) {
          this.selectedRatePlanId = company.rate_plan_id
          this.applyRatePlanValue()
        } else if (company.tariff_id) {
          // se tem uma tarifa cadastrada na empresa aplica no select tarifas
          this.editedItem.tariff_id = company.tariff_id
        }
        this.syncBillingByCompany(company)
      } else {
        this.resetBillingSettings()
      }
    },
    close() {
      this.dialogSave = false
      this.dialog = false
      this.selectedRatePlanId = null
      this.ratePlanItem = null
      this.resetBillingSettings()
      this.$nextTick(() => {
        this.editedItem = {
          ...this.defaultItem,
        }
      })
      this.autoTariffEnabled = true
    },
    formatDate(date) {
      // const date = this.date
      if (!date) return null
      const [year, month, day] = date.split('-')

      return `${day}/${month}/${year}`
    },
    getExportPdf() {
      this.exportPdf(this.editedItem.id)
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]))
          const fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', 'export.pdf')
          document.body.appendChild(fileLink)
          fileLink.click()
        })
        .catch(response => {
          // console.log(response)
        })
    },
    save() {
      if (!this.validations()) return

      const payload = {
        company_id: this.company.id,
        requester: this.editedItem.requester,
        room_category_id: this.editedItem.room_category_id,
        check_in: this.editedItem.check_in,
        check_out: this.editedItem.check_out,
        guest_name: this.getGuests[0].name,
      }
      if (!this.editedItem.id) {
        this.findReserve(payload)
          .then(response => {
            if (response.data.found) {
              this.$swal({
                title: 'Atenção',
                html: `<p>Já existe uma reserva com os mesmos dados.</p> <p> Reserve ID: <strong>${response.data.reserve.id}</strong></p>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Continuar mesmo assim',
                cancelButtonText: 'Cancelar',
                confirmButtonColor: '#16b1ff',
                cancelButtonColor: '#d33',
                reverseButtons: true, // coloca "cancelar" à esquerda
                position: 'center',
              }).then(result => {
                if (result.isConfirmed) {
                  this.dialogSave = true
                } else if (result.dismiss === this.$swal.DismissReason.cancel) {
                  this.value = false
                }
              })
            } else {
              this.dialogSave = true
            }
          })
          .catch(error => {
            console.error(error)
          })
      } else {
        this.dialogSave = true
      }
    },
    confirmSave() {
      if (this.company) {
        this.editedItem.company_id = this.company.id
      }

      if (!this.companyAllowsBilling) {
        this.editedItem.billing_checkout_enabled = false
        this.editedItem.billing_checkout_scope = null
      }

      if (this.editedItem.tariff_manual == 'yes') {
        this.editedItem.tariff_id = null
      } else {
        this.editedItem.tariff_manual_value = null
      }

      if (this.extraordinary_tariff.length > 0) {
        this.editedItem.extraordinary_tariff = this.extraordinary_tariff
      }

      if (this.editedItem.qtd_room > 1) {
        this.editedItem.isGroup = true
      }

      if (this.editedItem.id) {
        this.update(this.editedItem)
          .then(response => {
            const guest = response.data
            this.close()
            this.$emit('out_data', guest)
            this.$toast.success('Salvo com sucesso !')
            this.setGuests([]) // limpa a tabela hospedes
          })
          .catch()
          .finally(() => {
            this.loading = false
            this.loading_not = false
          })
      } else {
        this.store(this.editedItem)
          .then(response => {
            const guest = response.data
            this.$toast.success('Salvo com sucesso !')
            this.$emit('out_data', guest)
            this.resetForm() // Limpa o formulário após criar nova reserva
            this.close()
          })
          .catch()
          .finally(() => {
            this.loading = false
            this.loading_not = false
            this.dialogSave = false
          })
      }
    },
    resetForm() {
      // Reseta editedItem para valores padrão
      this.editedItem = { ...this.defaultItem }

      // Limpa campos extras
      this.company = ''
      this.tariff_manual_value = ''
      this.extraordinary_tariff = []
      this.tariffObject = {}
      this.resetBillingSettings()

      // Limpa tabela de hóspedes
      this.setGuests([])

      // Limpa erros
      this.errors = {
        room_category_id: null,
        tariff_id: null,
        tariff_manual_value: null,
        check_in: null,
        check_out: null,
        company_id: null,
        billing_checkout_scope: null,
        guest: null,
        qtd_room: null,
        room: [],
      }
    },
    validations() {
      const qtd = this.editedItem.qtd_room

      let validate = true

      // valida a cetegoria do quarto
      if (this.editedItem.room_category_id == null || this.editedItem.room_category_id == undefined) {
        this.errors.room_category_id = 'Campo obrigatório'
        validate = false
      }

      // valida tarifa padrao
      if (this.editedItem.tariff_manual == 'not') {
        // se estiver abilitado para tarifa padrao
        if (this.editedItem.tariff_id == null || this.editedItem.tariff_id == undefined) {
          this.errors.tariff_id = 'Campo obrigatório'
          validate = false
        }
      }

      // valida tarifa manual
      if (this.editedItem.tariff_manual == 'yes') {
        // se estiver abilitado para tarifa manual (aceita 0 para cortesia)

        if (
          this.tariff_manual_value == null
          || this.tariff_manual_value == undefined
          || this.tariff_manual_value === ''
        ) {
          this.errors.tariff_manual_value = 'Campo obrigatório'
          validate = false
        }
      }

      // valida checkin
      if (this.editedItem.check_in == null || this.editedItem.check_in == undefined || this.editedItem.check_in == '') {
        this.errors.check_in = 'Campo obrigatório'
        validate = false
      }

      // valida data checkout
      if (
        this.editedItem.check_out == null
        || this.editedItem.check_out == undefined
        || this.editedItem.check_out == ''
      ) {
        this.errors.check_out = 'Campo obrigatório'
        validate = false
      }

      // valida se tem hopede ou empresa
      const guest = false
      const company = false
      if (this.getGuests.length == 0) {
        this.errors.guest = 'Obrigatório preencher hóspede'
        validate = false
      }
      if (this.company == null || this.company == undefined || this.company == '') {
        this.errors.company_id = 'Obrigatório preencher empresa'
        validate = false
      }

      if (this.editedItem.billing_checkout_enabled && !this.editedItem.billing_checkout_scope) {
        this.errors.billing_checkout_scope = 'Selecione o escopo do faturamento.'
        validate = false
      }

      if (this.editedItem.billing_checkout_enabled && this.companyCredit.billing_blocked) {
        const tol = this.companyCredit.billing_overdue_tolerance != null ? ` (tolerância: ${this.companyCredit.billing_overdue_tolerance} dias)` : ''
        this.errors.billing_checkout_scope = `Faturamento bloqueado: faturas vencidas há ${this.companyCredit.overdue_days} dias${tol}.`
        validate = false
      }

      const effectiveAvailable = this.companyCredit.available + (this.editedItem.id ? this.originalCreditLock : 0)
      if (this.editedItem.billing_checkout_enabled && effectiveAvailable <= 0) {
        this.errors.billing_checkout_scope = 'Empresa sem saldo disponível para faturamento.'
        validate = false
      }

      if (this.editedItem.billing_checkout_enabled && !this.companyCredit.billing_blocked) {
        const scope = this.editedItem.billing_checkout_scope
        if (['total', 'accommodation', null].includes(scope)) {
          const rate = parseFloat(this.editedItem.accommodation_value || 0)
          const qty = Math.max(1, parseInt(this.editedItem.qtd_room || 1))
          const projected = rate * qty
          if (projected - effectiveAvailable > 0.01) {
            this.errors.billing_checkout_scope = `Crédito insuficiente. Saldo disponível: ${this.formatMoneyBR(effectiveAvailable)}`
            validate = false
          }
        }
      }

      if (guest && company) {
        this.errors.guest = 'Obrigatório preencher empresa ou hóspede'
        validate = false
      }

      if (!qtd || Number(qtd) <= 0) {
        this.errors.qtd_room = 'Campo obrigatório'
        validate = false
      }

      if (this.editedItem.children_count == null || this.editedItem.children_count == '') {
        this.editedItem.children_count = 0
      }

      return validate
    },

    showDialogResendVoucher() {
      this.emailResendVoucher = ''
      this.dialogResendVoucher = true
    },
    showDialogResendWhatsVoucher() {
      this.whatsResendVoucher = ''
      this.dialogResendVoucherWhats = true
    },
    sendVoucher() {
      const data = {
        reserve_id: this.editedItem.id,
        email: this.emailResendVoucher,
      }
      this.loadingResendVoucher = true
      this.resendVoucher(data)
        .then(response => {
          this.$toast.success('Email enviado com sucesso.')
          this.dialogResendVoucher = false
        })
        .finally(() => {
          this.loadingResendVoucher = false
        })
    },
    sendVoucherWhats() {
      const data = {
        reserve_id: this.editedItem.id,
        whats: this.whatsResendVoucherComp,
      }
      this.loadingResendVoucher = true
      this.resendWhatsVoucher(data)
        .then(response => {
          this.$toast.success('Mensagem enviada com sucesso.')
          this.dialogResendVoucherWhats = false
        })
        .finally(() => {
          this.loadingResendVoucher = false
        })
    },
    reOpenButton() {
      this.loading = true
      this.reOpen(this.editedItem)
        .then(response => {
          const guest = response.data
          this.close()
          this.$emit('out_data', guest)
          this.$toast.success('Reserva reativada com sucesso.')
          this.setGuests([]) // limpa a tabela hospedes
        })
        .catch()
        .finally(() => {
          this.loading = false
          this.loading_not = false
        })
    },
    onRoomChange(value) {
      this.editedItem.qtd_room = value.length
      this.errors.qtd_room = null // Limpa o erro quando quartos são selecionados
    },

  },
}
</script>

<style scoped>
.card-tab {
  min-height: 420px;
  min-width: 736px;
}

.svg-icon {
  height: 52px;

}

.tool_table_fam {
  height: 50px;
}
</style>
